import {UI} from "../../../../../stem-core/ui/UIBase";
import {UserDashboardSection} from "./UserDashboardSection.jsx";
import {Link} from "../../../../../stem-core/ui/UIPrimitives";

export function UserDashboardCDSAccountSection(cdsSocialAccount) {
    if (!cdsSocialAccount) {
        return null;
    }

    const cdsAccountNumber = cdsSocialAccount.getCDSAccountNumber();
    const cdsZipCode = cdsSocialAccount.extraData?.customer?.zipCode;
    const cdsProductId = cdsSocialAccount.extraData?.cdsProductId?.substr(0, 3) || "NUB";

    const cdsURL = cdsZipCode ? `https://w1.buysub.com/servlet/RemoteLoginGateway?cds_mag_code=${cdsProductId}&cds_pub_code=N2&cds_page_id=261319&cds_account_number=${cdsAccountNumber}&cds_zip=${cdsZipCode}&cds_query_type=Z&cds_login_type=S&cds_return_url=https://w1.buysub.com/servlet/FakeClient%3Frc%3D`
                              : `https://w1.buysub.com/pubs/N2/${cdsProductId}/login.jsp?cds_mag_code=${cdsProductId}`;

    return <UserDashboardSection titleMessage="Account Number">
        <div>
            Your customer support account number is <strong>{cdsAccountNumber}</strong>.
        </div>
        <div>
            Manage your subscription account <Link newTab href={cdsURL} label="here"/>.
        </div>
    </UserDashboardSection>;
}
